/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Container, Row, Col, Spinner } from "react-bootstrap";
import useNewCreateAssessment from "./useNewCreateAssessment";
import "./NewCreateAssessment.scss";
import "react-datepicker/dist/react-datepicker.css";
import {
  faCircleInfo,
  faMinusCircle,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Header from "../../../Common/Header";
import TextEditor from "../../../Common/Editor";
import Footer from "../../../Common/Footer/Footer";
import MainLayout from "../../../Common/MainLayout";

export default (props) => {
  const {
    formData,
    saveLoading,
    outroNoteEditor,
    welcomeNoteEditor,
    formInputsError,
    continueLoading,
    previewLoading,
    dueDate,
    loading,
    // showCreateQuestion,
    onTitleChange,
    onCancelClick,
    onSaveClick,
    onInputChange,
    openEditor,
    onDeleteClick,
    onCreateNewTopic,
    calculateAssessmentEstimatedTime,
    onTotalQuestionChange,
  } = useNewCreateAssessment(props);
  return (
    <MainLayout pageName={"assessment kit"}>
      <div className="create-interview footer-gap">
        <div className="top bg-grey pb-4">
          <Container className="d-flex justify-content-between align-items-center">
            <h2 className="text-dark text-capitalize">
              {formData?.title && formData.title.length > 0
                ? formData?.title
                : "Create video assessment kit"}
            </h2>
            <span className="d-flex align-items-center ml-2">
              <button
                className="btn border-0 bg-transparent text-dark"
                onClick={onCancelClick}
              >
                {"Cancel & Return"}
              </button>
              <button
                className="btn btn-outline-light bg-grey-5 ml-2"
                onClick={() => onSaveClick("preview", "draft")}
              >
                {previewLoading ? (
                  <Spinner animation="border" variant="primary" />
                ) : (
                  "Save & Preview"
                )}
              </button>
            </span>
          </Container>
        </div>

        <Container>
          <Row>
            <Col lg={12}>
              <div className="job-detail mt-5 bg-grey-5 px-3">
                <div className="top bg-grey-2 py-3 px-4 mx-n3">
                  <h3 className="font-weight-medium">Welcome page intro</h3>
                </div>
                <Row className="bg-white rounded-lg mx-2 my-4 shadow-2">
                  <Col lg={8}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Title
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Enter Assessment Kit Title"
                        name="title"
                        onBlur={(e) => onTitleChange(e)}
                        defaultValue={formData && formData?.title}
                      />
                      {formInputsError.title &&
                      formInputsError.title.length > 0 ? (
                        <span className="text-danger mt-1 line-height-14 d-inline-block">
                          {formInputsError.title}
                        </span>
                      ) : null}
                    </div>
                  </Col>
                  <Col lg={4}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Total Number of
                        Questions
                      </p>
                      <div>
                        <input
                          className="form-control bg-transparent"
                          type="text"
                          placeholder="Number of Question"
                          onBlur={(e) => onTotalQuestionChange(e)}
                          defaultValue={formData && formData?.total_question}
                        />
                      </div>
                    </div>
                  </Col>

                  {/* <Col lg={12}>
                  <div className="form-group mb-0 py-3">
                    <p className="font-weight-medium">
                      Welcome note (optional)
                    </p>
                    <div>
                      {welcomeNoteEditor ? (
                        <TextEditor
                          htmlData={formData && formData?.welcome_note}
                          getHtmlData={(data) =>
                            onInputChange({
                              target: { value: data, name: "welcome_note" },
                            })
                          }
                        />
                      ) : (
                        <div
                          className="note form-control placeholder text-grey-4 fs-smallest"
                          onClick={() => openEditor("welcome_note")}
                        >
                          {formData?.welcome_note &&
                          formData?.welcome_note.length > 0 ? (
                            <div
                              dangerouslySetInnerHTML={{
                                __html: formData?.welcome_note,
                              }}
                              className="pt-2"
                            ></div>
                          ) : (
                            "Click to enter welcome notes here."
                          )}
                        </div>
                      )}
                    </div>
                  </div>
                </Col> */}
                </Row>

                {formData?.id && (
                  <>
                    <div className="top bg-grey-2 py-3 mx-n3 px-4 d-flex justify-content-between align-items-center">
                      <h3 className="font-weight-medium pb-2">Questions</h3>
                      <span className="">
                        Estimated Time: {calculateAssessmentEstimatedTime()}{" "}
                        mins
                      </span>
                    </div>
                    {formData?.topics &&
                    Array.isArray(formData?.topics) &&
                    formData?.topics.length > 0 ? (
                      <div className="bg-white mx-2 my-4 rounded-lg shadow-2">
                        <div className="text-center p-3">
                          <p className="my-2">
                            {formData?.topics &&
                              Array.isArray(formData.topics) &&
                              formData.topics.map((topic) => (
                                <ol className="questions-wrapper mb-0 my-3">
                                  <div className="top bg-grey-2 py-3 px-3 border d-flex justify-content-between align-items-center">
                                    <h4 className="font-weight-medium text-left">
                                      {topic?.name && topic.name.toUpperCase()}
                                    </h4>
                                    <div
                                      className="right-icons d-flex align-items-center"
                                      onClick={() =>
                                        onCreateNewTopic(topic?.id)
                                      }
                                    >
                                      <FontAwesomeIcon
                                        icon={faPencil}
                                        className="text-grey-4 cursor-pointer"
                                      />
                                    </div>
                                  </div>
                                  {topic?.questions &&
                                    Array.isArray(topic.questions) &&
                                    topic.questions.map((question, index) => (
                                      <li className="list d-flex align-items-center">
                                        <span className="d-inline-block border p-3">
                                          {index + 1}
                                        </span>
                                        <div className="inner-box-new d-flex flex-grow-1 justify-content-between align-items-center ">
                                          <p className="d-inline-block mb-0 mr-2">
                                            {question.question}
                                          </p>
                                          <div>
                                            <p className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-sm">
                                              {question.time_to_answer} mins to
                                              answer
                                            </p>
                                            <span className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-sm">
                                              {question?.skill_names &&
                                                question.skill_names[0]}
                                            </span>
                                            <span className="mb-0 d-inline-block text-primary mr-2 py-1 px-2 bg-light-blue rounded-sm">
                                              {question?.is_public
                                                ? "Public"
                                                : "Private"}
                                            </span>
                                          </div>
                                        </div>
                                      </li>
                                    ))}
                                </ol>
                              ))}
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div className="bg-white p-3 rounded-lg shadow-2 mx-2 mt-4">
                        <div className="msg-bg text-white p-3 border-6 mt-4 d-flex align-items-center justify-content-center mb-2 mw-75 mx-auto">
                          <p className="mb-0">
                            <FontAwesomeIcon
                              icon={faCircleInfo}
                              className="text-white mr-2"
                            />
                            No questions in your video assessment kit, yet.
                          </p>
                        </div>
                        <p className="my-4 font-weight-medium text-center">
                          Create a new topic to start adding them!
                        </p>
                      </div>
                    )}

                    <div className="text-center">
                      <button
                        onClick={() => onCreateNewTopic()}
                        className="create-btn text-center bg-transparent p-4 my-4 mx-auto rounded-lg text-primary font-weight-medium"
                      >
                        + Create new topic
                      </button>
                    </div>
                  </>
                )}

                <div className="top bg-grey-2 py-3 px-4 mx-n3">
                  <h3 className="font-weight-medium">Epilogue</h3>
                </div>

                <Row className="bg-white rounded-lg shadow-2 mx-2 my-4">
                  <Col lg={12}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        <span className="text-danger">* </span>Title
                      </p>
                      <input
                        className="form-control bg-transparent"
                        type="text"
                        placeholder="Thanks for sharing this video interview with Zydelo"
                        name="epilogue_title"
                        onChange={(e) => onInputChange(e)}
                        defaultValue={formData && formData?.epilogue_title}
                      />
                      {formInputsError.epilogue_title &&
                      formInputsError.epilogue_title.length > 0 ? (
                        <span className="text-danger mt-1 line-height-14 d-inline-block">
                          {formInputsError.epilogue_title}
                        </span>
                      ) : null}
                    </div>
                  </Col>

                  <Col lg={12}>
                    <div className="form-group mb-0 py-3">
                      <p className="font-weight-medium">
                        Outro note
                      </p>
                      <div>
                        {outroNoteEditor ? (
                          <TextEditor
                            htmlData={formData && formData?.epilogue_outro_note}
                            getHtmlData={(data) =>
                              onInputChange({
                                target: {
                                  value: data,
                                  name: "epilogue_outro_note",
                                },
                              })
                            }
                          />
                        ) : (
                          <div
                            className="note form-control placeholder text-grey-4 fs-smallest"
                            onClick={(e) => openEditor("epilogue_outro_note")}
                          >
                            {formData?.epilogue_outro_note &&
                            formData?.epilogue_outro_note.length > 0 ? (
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: formData?.epilogue_outro_note,
                                }}
                                className="pt-2"
                              ></div>
                            ) : (
                              "Click to enter epilogue notes here."
                            )}
                          </div>
                        )}
                        {formInputsError?.epilogue_outro_note &&
                        formInputsError.epilogue_outro_note.length > 0 ? (
                          <span className="text-danger mt-1 line-height-14 d-inline-block">
                            {formInputsError.epilogue_outro_note}
                          </span>
                        ) : null}
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="top bg-grey-2 py-3 px-4 mx-n3">
                  <h3 className="font-weight-medium">Settings</h3>
                </div>
                <Row className="settings mt-3 mx-n2">
                  <Col lg={6}>
                    <div className="d-flex align-items-center rounded-lg my-3 p-3 setting-type shadow-2 bg-white">
                      <div className="custom-control custom-radio mr-3">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="setting"
                          id="TopicsQuestions2"
                          onChange={(e) => onInputChange(e)}
                          value={"topics_only"}
                          defaultChecked={
                            formData && formData?.setting === "topics_only"
                              ? "checked"
                              : null
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="TopicsQuestions2"
                        ></label>
                      </div>

                      <img
                        src="../assets/images/progress-loading.png"
                        alt="loading"
                        className="mr-3"
                      />

                      <div>
                        <h3 className="font-weight-semi">Topics only</h3>
                        <p className="text-grey-4 font-weight-normal ">
                          Allow the candidates to preview topics only, before
                          starting the interview.
                        </p>
                      </div>
                    </div>
                  </Col>

                  <Col lg={6}>
                    <div className="d-flex align-items-center rounded-lg my-3 p-3 setting-type shadow-2 bg-white">
                      <div className="custom-control custom-radio mr-3">
                        <input
                          className="custom-control-input"
                          type="radio"
                          name="setting"
                          id="TopicsQuestions3"
                          onChange={(e) => onInputChange(e)}
                          value="no_visibility"
                          defaultChecked={
                            formData && formData?.setting === "no_visibility"
                              ? "checked"
                              : null
                          }
                        />
                        <label
                          className="custom-control-label"
                          htmlFor="TopicsQuestions3"
                        ></label>
                      </div>

                      <img
                        src="../assets/images/eye-icon-3.png"
                        alt="loading"
                        className="mr-3"
                      />

                      <div>
                        <h3 className="font-weight-semi">No visibility</h3>
                        <p className="text-grey-4 font-weight-normal ">
                          Don’t allow the candidates to preview the content of
                          the interview.
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>

                <div className="action py-4 border-top mt-3">
                  <button
                    className="btn btn-primary"
                    onClick={() => onSaveClick("save", "draft")}
                  >
                    {saveLoading ? (
                      <Spinner animation="border" variant="white" />
                    ) : (
                      "Save all changes"
                    )}
                  </button>
                  <button
                    className="btn btn-outline-light bg-grey-5 ml-3 text-dark"
                    onClick={() => onSaveClick("continue", "publish")}
                  >
                    {continueLoading ? (
                      <Spinner animation="border" variant="primary" />
                    ) : (
                      "Save and continue"
                    )}
                  </button>
                  {formData?.id && (
                    <>
                      {loading ? (
                        <div className="d-inline-block ml-4">
                          <Spinner animation="border" variant="primary" />
                        </div>
                      ) : (
                        <button
                          className="border-0 bg-transparent text-danger ml-3 text-nowrap"
                          onClick={() => onDeleteClick()}
                        >
                          <FontAwesomeIcon
                            icon={faMinusCircle}
                            className="mr-2"
                          />
                          Delete
                        </button>
                      )}
                    </>
                  )}
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </MainLayout>
  );
};
